module.exports = __webpack_public_path__ + "static/img/2.e06b86fe.png";